<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from  "../components/card.svelte";
    import SubscriptionForm from "./subscriptionform.svelte";
    import SubscriptionNotes from "./subscriptionnotes.svelte";
    import SubscriptionHistory from "./subscriptionhistory.svelte";
    import Router from "../../router.js";
    import Permissions from "../permissions/permissionsComponent.svelte";
    
    export let customersID;
    export let showPermissions="";
  
    const promise = wrappedFetch('/api/subscriptions/GetCustomerDetails?CustomerID=' + customersID).then(response => response.json())

    let ShowRenewal = false;
    let ShowSubscription = false;
    let ShowPending = false;
    let ShowDeactive = false;
    let ShowDelete = true;
    let showNotes
    let ShowNotes = true;
    let showHistory;
    let userHistory = false;
    let ModalConfirmation = false;
    let NewNote = false;
    let showDeactivitionModal = false;
    let exportarchived = false;
    let pageTitle = "Subscriptions | Wavenet Nimbus";
    
    const resetModal=async()=>{
        jQuery('.nav-tabs a[href="#sub1"]').tab('show');
        NewNote = false
        ModalConfirmation = false;
        userHistory = false;
        showDeactivitionModal = false;
        ShowRenewal = false;
        ShowDeactive = false;
        //exportrenewalstatus = [];
    }

    let exportreset = false;
    $: if (exportreset) {
        resetModal();
    }  
    
    let userDeactived = false;
    $: if (userDeactived) {
        resetModal();
        //back();
        Router.route("/app/subscriptions");
    }   
    
    $: if (exportarchived) {
        window.location.href = '/app/subscriptions';
        //OnPageLoad();
    }

    const showPermissionsTab = ()=>{
        if(showPermissions == "permissions") 
            jQuery('.nav-tabs a[href="#sub2"]').tab('show')
    }    
</script>

<svelte:head>
    <title>{pageTitle}</title>
</svelte:head>

<h1>Edit Subscription</h1>

<div class="row">
    <div class="col-12">
        <a class="btn btn-grey mb-3" href="/app/subscriptions"><i
                class="fas fa-arrow-left" />
            Back</a>
    </div>
</div>

{#await promise then selectedUser}
    <div class="row">
        <div class="col-12">
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#sub1">Details</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#sub2" >Permissions</a>
                </li>
                {#if !ShowPending}
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#sub4" on:click|preventDefault={showHistory.showAllHistory}>History</a>
                </li>
                {/if}
                {#if ShowNotes}
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#sub3" on:click|preventDefault={showNotes.showAllNotes}>Notes</a>
                </li>
                {/if}
                {#if selectedUser.matName}
                    {#if selectedUser.matName.length > 0}
                        <li class="nav-item ml-auto">
                            <a class="nav-link">{selectedUser.matName}</a>
                        </li> 
                    {/if}
                {/if}
            </ul>
        </div>
    </div>        
    <div class="row">
        <div class="col-12">
            <div class="tab-content">
                <div class="tab-pane active" id="sub1">
                    <Card>
                        <div slot="body">
                            <SubscriptionForm {pageTitle} isEdit={selectedUser.isEnabled} ShowSubscription={selectedUser.isEnabled} ShowPending={!selectedUser.isEnabled} 
                            {ShowDelete} userDetails={selectedUser}                         
                            bind:exportarchived={exportarchived}/>
                        </div>
                    </Card>      
                </div>
                <div class="tab-pane" id="sub2" use:showPermissionsTab>
                    <Card>
                        <div slot="body">
                            <p>
                                These users are able to manage your school's settings including
                                enabling new apps and approving the release of your school's data to
                                third parties.
                            </p>
                           <Permissions {pageTitle} schoolId={selectedUser.schoolID}/>
                        </div>
                    </Card>      
                </div>
                <div class="tab-pane" id="sub3">
                    <Card>
                        <div slot="body">
                            <SubscriptionNotes bind:this={showNotes} {NewNote} {ModalConfirmation} userDetails={selectedUser} bind:exportreset={exportreset}></SubscriptionNotes> 
                        </div>
                    </Card>                            
                </div>
                <div class="tab-pane" id="sub4">
                    <Card>
                        <div slot="body">
                            <SubscriptionHistory bind:this={showHistory} {ShowRenewal} {ShowDeactive} {ModalConfirmation} {userHistory} {showDeactivitionModal} userDetails={selectedUser} bind:exportreset={exportreset} bind:userDeactived={userDeactived}></SubscriptionHistory> 
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    </div>
{/await}
